import { useEffect, useState } from 'react';

/** Subscribes to a CSS media query and returns whether it currently matches.
 *  SSR-safe: returns `defaultValue` before hydration (no window access). */
export function useMediaQuery(query: string, defaultValue = false): boolean {
  const [matches, setMatches] = useState<boolean>(() => {
    if (typeof window === 'undefined') return defaultValue;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const mq = window.matchMedia(query);
    const handler = (): void => {
      setMatches(mq.matches);
    };
    handler();
    mq.addEventListener('change', handler);
    return () => {
      mq.removeEventListener('change', handler);
    };
  }, [query]);

  return matches;
}
